import claude from "@/assets/logos/claude.svg";
import heygen from "@/assets/logos/heygen.svg";
import elevenlabs from "@/assets/logos/elevenlabs.svg";
import luma from "@/assets/logos/luma.svg";
import falai from "@/assets/logos/falai.svg";
import meta from "@/assets/logos/meta.svg";
import tiktok from "@/assets/logos/tiktok.svg";
import google from "@/assets/logos/google.svg";
import youtube from "@/assets/logos/youtube.svg";

const OPENAI_PATH = "M22.2819 9.8211a5.9847 5.9847 0 0 0-.5157-4.9108 6.0462 6.0462 0 0 0-6.5098-2.9A6.0651 6.0651 0 0 0 4.9807 4.1818a5.9847 5.9847 0 0 0-3.9977 2.9 6.0462 6.0462 0 0 0 .7427 7.0966 5.98 5.98 0 0 0 .511 4.9107 6.051 6.051 0 0 0 6.5146 2.9001A5.9847 5.9847 0 0 0 13.2599 24a6.0557 6.0557 0 0 0 5.7718-4.2058 5.9894 5.9894 0 0 0 3.9977-2.9001 6.0557 6.0557 0 0 0-.7475-7.0729zm-9.022 12.6081a4.4755 4.4755 0 0 1-2.8764-1.0408l.1419-.0804 4.7783-2.7582a.7948.7948 0 0 0 .3927-.6813v-6.7369l2.02 1.1686a.071.071 0 0 1 .038.052v5.5826a4.504 4.504 0 0 1-4.4945 4.4944zm-9.6607-4.1254a4.4708 4.4708 0 0 1-.5346-3.0137l.142.0852 4.783 2.7582a.7712.7712 0 0 0 .7806 0l5.8428-3.3685v2.3324a.0804.0804 0 0 1-.0332.0615L9.74 19.9502a4.4992 4.4992 0 0 1-6.1408-1.6464zM2.3408 7.8956a4.485 4.485 0 0 1 2.3655-1.9728V11.6a.7664.7664 0 0 0 .3879.6765l5.8144 3.3543-2.0201 1.1685a.0757.0757 0 0 1-.071 0l-4.8303-2.7865A4.504 4.504 0 0 1 2.3408 7.872zm16.5963 3.8558L13.1038 8.364 15.1192 7.2a.0757.0757 0 0 1 .071 0l4.8303 2.7913a4.4944 4.4944 0 0 1-.6765 8.1042v-5.6772a.79.79 0 0 0-.407-.667zm2.0107-3.0231l-.142-.0852-4.7735-2.7818a.7759.7759 0 0 0-.7854 0L9.409 9.2297V6.8974a.0662.0662 0 0 1 .0284-.0615l4.8303-2.7866a4.4992 4.4992 0 0 1 6.6802 4.66zM8.3065 12.863l-2.02-1.1638a.0804.0804 0 0 1-.038-.0567V6.0742a4.4992 4.4992 0 0 1 7.3757-3.4537l-.142.0805L8.704 5.459a.7948.7948 0 0 0-.3927.6813zm1.0976-2.3654l2.602-1.4998 2.6069 1.4998v2.9994l-2.5974 1.4997-2.6067-1.4997Z";

type LogoEntry =
  | { type: "image"; src: string; alt: string }
  | { type: "svg"; path: string; alt: string };

const logos: LogoEntry[] = [
  { type: "image", src: claude, alt: "Claude AI" },
  { type: "svg", path: OPENAI_PATH, alt: "OpenAI" },
  { type: "image", src: heygen, alt: "HeyGen" },
  { type: "image", src: elevenlabs, alt: "ElevenLabs" },
  { type: "image", src: luma, alt: "Luma AI" },
  { type: "image", src: falai, alt: "fal.ai" },
  { type: "image", src: meta, alt: "Meta" },
  { type: "image", src: tiktok, alt: "TikTok" },
  { type: "image", src: google, alt: "Google" },
  { type: "image", src: youtube, alt: "YouTube" },
];

export function PoweredByMarquee({ label = "Powered by" }: { label?: string }) {
  const loop = [...logos, ...logos];
  return (
    <div className="w-full">
      <p className="text-xs uppercase tracking-[0.25em] text-white text-center mb-6">{label}</p>
      <div className="relative overflow-hidden marquee-mask">
        <div className="flex w-max animate-marquee gap-8 sm:gap-10 md:gap-12 lg:gap-14 items-end py-2">
          {loop.map((l, i) =>
            l.type === "svg" ? (
              <div
                key={i}
                className="flex flex-col items-center gap-1.5 shrink-0"
                title={l.alt}
              >
                <div className="flex items-center justify-center h-5 sm:h-6 md:h-7 w-16 sm:w-20 md:w-24 opacity-80 hover:opacity-100 transition duration-300">
                  <svg
                    role="img"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-full w-auto fill-white"
                    aria-label={l.alt}
                  >
                    <path d={l.path} />
                  </svg>
                </div>
                <span className="text-[9px] uppercase tracking-widest text-white/50 text-center leading-none">{l.alt}</span>
              </div>
            ) : (
              <div
                key={i}
                className="flex flex-col items-center gap-1.5 shrink-0"
                title={l.alt}
              >
                <div className="flex items-center justify-center h-5 sm:h-6 md:h-7 w-16 sm:w-20 md:w-24">
                  <img
                    src={l.src}
                    alt={l.alt}
                    className="max-h-full max-w-full w-auto object-contain brightness-0 invert opacity-80 hover:opacity-100 transition duration-300"
                    loading="lazy"
                  />
                </div>
                <span className="text-[9px] uppercase tracking-widest text-white/50 text-center leading-none">{l.alt}</span>
              </div>
            )
          )}
        </div>
      </div>
    </div>
  );
}
